export default function PersonnelFormSection({ title, children }) {
  return (
    <section className="personnel-section" aria-label={title}>
      <h2>{title}</h2>
      <div className="personnel-grid">{children}</div>
    </section>
  );
}
